module.exports = __webpack_public_path__ + "img/messages-active.01fa301b.svg";